<!-- 个人中心 -->
<template>
  <el-row style="margin-top: 30px">
    <el-col :span="4">
      <el-card class="leftpersonal" :body-style="{padding:'0px', minWidth:'200px'}">
        <div style="display: flex;flex-direction: column">
          <div class="frame">
            <img :src="user.image_url"></div>
          <div>
            <p class="name" @click="changName">
              {{ user.nickname }}
              <input v-show="changing_name" name="nickname"
                     v-model="input_nickname" @blur="updateNickName"
                     @keyup.enter="input_nickname" ref="input_nickname"
                     id="input_nickname" placeholder="在此输入您的新名字"/>
            </p>
          </div>

          <div style="height: 1px;width: 100%;background-color: #f2f2f2"></div>
          <ul class="funcs">
            <router-link tag="li" :to="{ name: 'PersonalCourseList',
                          params: { user_id: user.user_id }}">我的课程
            </router-link>
            <router-link tag="li" :to="{ name: 'PersonalOrderList',
                          params: { user_id: user.user_id }}">我的订单
            </router-link>
            <router-link tag="li" :to="{ name: 'PersonalQuiz',
                          params: { user_id: user.user_id }}">我的问答
            </router-link>
            <li @click="dialogVisible = true">优惠码购课</li>
          </ul>
        </div>
      </el-card>
    </el-col>
    <el-col :span="20" :offset="4">
      <el-card style="margin-left: 50px;background-color: #fff;border-radius: 8px;" :body-style="{padding:'0px'}">
        <router-view></router-view>
      </el-card>
    </el-col>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>请输入优惠码</span>
      <el-input style="margin-left: 0;margin-top: 20px;margin-right: 20px" v-model="payCode"
                placeholder="请输入优惠码"></el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose(false)">取 消</el-button>
    <el-button type="primary" @click="handleClose(true)">确 定</el-button>
  </span>
    </el-dialog>
  </el-row>
</template>
<script>
import urls from '../../common/js/urls.js'

export default {
  name: "index",
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  data() {
    return {
      input_nickname: '',
      changing_name: false,
      dialogVisible: false,
      payCode: '',
    }
  },
  watch: {
    user: function (val) {
      if (!val.user_id || val.user_id == '') {
        this.$message.error('登录超时，请重新登录');
        this.$router.go('{name:Index}')
        return false
      }
    }
  },
  methods: {
    changName: function (ev) { //点击输入
      this.changing_name = true
      window.setTimeout(function () {
        document.getElementById("input_nickname").focus()
      }, 50);
    },
    updateNickName: function () { //输入完失去焦点保存
      this.changing_name = false
      var temp = this.input_nickname
      var _this = this
      if (temp !== '' && !!this.user.user_id) {
        //更新用户基本信息
        this.axios.post(urls.set_info + "?user_id=" + this.user.user_id + "&nick_name=" + temp).then(function (response) {
          if (response.data.code != 200) return false
          _this.$store.commit('update_user', {'nick_name': temp, 'nickname': temp})
          _this.input_nickname = ''
        })
      }
    },
    handleClose(done) {
      let context = this;
      if (done) {
        if (this.payCode.length !== 6) {
          this.$message.error('请输入正确的优惠码');
        } else {
          this.$router.push({
            name: 'Order',
            query: {
              payCode: context.payCode,
            }
          })
          this.dialogVisible = false;
          this.payCode = '';
        }
      } else {
        this.dialogVisible = false;
      }
    }
  },
}

</script>
<style scoped>

.frame img {
  width: 120px !important;
  height: 120px !important;
  border-width: 0 !important;
  border-radius: 50% !important;
}

.name {
  margin-bottom: 27px;
  text-align: center;
  width: 100%;
  font-size: 22px;
  color: #333;
  line-height: 33px;
  position: relative;
}

#input_nickname {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 10%;
  right: 0;
  margin-bottom: 27px;
  height: 100%;
  width: 80%;
  padding: 3px 5px;
  font-size: 14px;
  border: none;
}

.funcs {
  padding-left: 0;
}

.funcs li {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  list-style-type: none;
  height: 45px;
  line-height: 44px;
  cursor: pointer;
}

.funcs .router-link-exact-active,
.funcs li:hover {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #FFEBCD none repeat scroll 0 0;
  border-left: 5px solid #ffbc42;
  color: #fcb200;
  list-style-type: none;
  height: 45px;
  cursor: pointer;
}

.funcs li b.right {
  float: right;
  padding-right: 17px;
}

.leftpersonal {
  position: fixed;
  border-radius: 8px;
}

.frame {
  margin-left: 45px !important;
  margin-right: 45px !important;
  text-align: center !important;
  margin-top: 45px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Personal/Personal.vue